import { useBackgroundSync } from '@/context/BackgroundSyncContext';
import ErrorExclamationIcon from '@/assets/icons/error-exclamation.svg?react';
import Tooltip from '@/common/Tooltip/Tooltip';
import styles from './SyncIndicator.module.scss';

interface ISyncIndicatorProps {
  className?: string;
}

export default function SyncIndicator({ className = '' }: ISyncIndicatorProps) {
  const { syncStatus } = useBackgroundSync();

  if (syncStatus === 'done') return null;

  return (
    <div className={`${styles.indicatorWrapper} ${className}`}>
      {syncStatus === 'syncing' && <div className={styles.spinner} />}
      {/* {syncStatus === 'done' && <CheckmarkIcon className={styles.successIcon} />} */}
      {syncStatus === 'error' && (
        <Tooltip content="There was a problem syncing the app data. Please check your connection and try again." position="bottom">
          <ErrorExclamationIcon className={styles.errorIcon} />
        </Tooltip>
      )}
    </div>
  );
}
